// extracted by mini-css-extract-plugin
export default {"box":"styles_box__9gYjK","title":"styles_title__it0f2","termsLabel":"styles_termsLabel__Ayibj","terms":"styles_terms__rXH6l","message":"styles_message__vLhgq"};